import { round } from 'utils/numbers';

import Cart from 'models/Cart';
import CartItem from 'models/CartItem';

class CartCapacity {
  meals: number;
  volume: number;

  constructor(cart: Cart) {
    this.meals = cart.validations.maximum_meals;
    this.volume = cart.validations.maximum_volume;
  }

  reduce(cartItem: CartItem): void {
    const { quantity } = cartItem;

    if (!cartItem.isSnack) this.meals -= quantity;
    this.volume = round(this.volume - quantity * cartItem.skuVolume);
  }
}

export default CartCapacity;
